<template>
  <div class="notifications__wrapper">
    <div v-if="notifications.toasts.length" class="toasts">
      <app-toast
        v-for="toast in notifications.toasts"
        :key="toast.id"
        :toast="toast"
      />
    </div>
    <div v-if="notifications.modal" class="modal__wrapper">
      <app-modal :modal="notifications.modal" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import AppToast from '@@/shared/notifications/Toast';
import AppModal from '@@/shared/notifications/Modal';

export default {
  components: {
    AppToast,
    AppModal
  },
  computed: {
    ...mapState(['notifications'])
  }
};
</script>
<style lang="scss" src="./wrapper.scss" />
